export const appColors = {
  siteHeroBg: "#FFFFFF",
};
